// Cookie Banner
function activateCookiebanner() {
  let resizeTimer;

  function adjustCookieBannerHeight() {
    const cookieBanner = document.getElementById('ww_bzga_matomo_cookiebanner');
    const description = document.getElementById('cookiebanner_description_moreinfo');

    if (cookieBanner && description) {
      const windowHeight = window.innerHeight;

      // Get the current height of the cookie banner
      const cookieBannerHeight = cookieBanner.offsetHeight;

      // Get the current height of the description
      const descriptionHeight = description.offsetHeight;

      // Calculate other content height by subtracting description height from total banner height
      const otherContentHeight = cookieBannerHeight - descriptionHeight;

      // Calculate available height for description
      const availableHeight = windowHeight - otherContentHeight - 40; // 40px for some padding

      // Set the height if it's reasonable
      if (availableHeight > 100) {
        description.style.height = availableHeight + 'px';
        description.style.overflowY = 'auto';
      }
    }
  }

  const moreInfoButton = document.getElementById('cookiebanner_button_moreinfo');
  if (moreInfoButton) {
    moreInfoButton.addEventListener('click', function () {
      document.body.classList.toggle('cookie-banner-open');
      // Adjust height after toggle
      setTimeout(adjustCookieBannerHeight, 10);
    });
  }

  // Call immediately since we're already in DOMContentLoaded
  adjustCookieBannerHeight();

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      adjustCookieBannerHeight();
    }, 250);
  });
}

// Matomo Tracking Code
function ww_bzga_matomo_embedTrackingCode() {
  var u = 'https://piwik.bzga.de/';
  window._paq = window._paq || [];
  window._paq.push(['setTrackerUrl', u + 'piwik.php']);

  var d = document,
    g = d.createElement('script'),
    s = d.getElementsByTagName('script')[0];
  g.type = 'text/javascript';
  g.defer = true;
  g.async = true;
  g.src = u + 'piwik.js';
  s.parentNode.insertBefore(g, s);
}

function ww_bzga_matomo_getCookie(cookieName) {
  const cookies = document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .filter((cookie) => cookie.startsWith(`${cookieName}=`));

  if (cookies.length === 0) {
    return null;
  }

  return cookies[0].split('=')[1];
}

function ww_bzga_matomo_setCookie(name, value, expiryDays, domain, path) {
  expiryDays = expiryDays || 365;
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiryDays);

  var cookie = [
    name + '=' + value,
    'expires=' + exdate.toUTCString(),
    'path=' + path || '/',
    'SameSite=Lax',
    'secure=true',
  ];

  if (domain && 0) cookie.push('domain=' + domain);
  if (value == 0) cookie.push('max-age=0');

  document.cookie = cookie.join(';');
}

function ww_bzga_matomo_set_tracking(v, expiryDays) {
  expiryDays = parseInt(expiryDays);

  if (expiryDays < 1) expiryDays = 365;

  ww_bzga_matomo_setCookie('ww_bzga_matomo_tracking_allow', v, expiryDays, document.domain, '/');

  ww_bzga_matomo_setCookie('ww_bzga_matomo_cookiebanner_hide', 1, expiryDays, document.domain, '/');

  const cookieBanner = document.querySelector('#ww_bzga_matomo_cookiebanner');
  if (cookieBanner) {
    cookieBanner.remove();
  }
}

function ww_bzga_matomo_set_moreinfo() {
  const moreInfoButton = document.querySelector('#cookiebanner_button_moreinfo');
  const moreInfoDescription = document.querySelector('#cookiebanner_description_moreinfo');

  if (moreInfoButton && moreInfoDescription) {
    const isExpanded = moreInfoButton.getAttribute('aria-expanded');

    if (isExpanded === 'true') {
      moreInfoDescription.style.display = 'none';
      moreInfoButton.setAttribute('aria-expanded', 'false');
    } else {
      moreInfoDescription.style.display = 'block';
      moreInfoButton.setAttribute('aria-expanded', 'true');
    }
  }
}

function ww_bzga_matomo_init() {
  var hide = ww_bzga_matomo_getCookie('ww_bzga_matomo_cookiebanner_hide');
  var allow = ww_bzga_matomo_getCookie('ww_bzga_matomo_tracking_allow');
  if (allow == null) allow = 2;

  if (allow == 1) ww_bzga_matomo_embedTrackingCode();

  const cookieBanner = document.querySelector('#ww_bzga_matomo_cookiebanner');
  if (cookieBanner) {
    if (hide != 1) {
      cookieBanner.classList.add('is-active');
    }

    const expire = cookieBanner.dataset.expire;

    const allowButton = cookieBanner.querySelector('.button-allow');
    const denyButton = cookieBanner.querySelector('.button-deny');
    const moreInfoButton = cookieBanner.querySelector('.button-moreinfo');

    if (allowButton) {
      allowButton.addEventListener('click', function () {
        ww_bzga_matomo_set_tracking(1, expire);
        location.reload();
      });
    }

    if (denyButton) {
      denyButton.addEventListener('click', function () {
        ww_bzga_matomo_set_tracking(2, expire);
        location.reload();
      });
    }

    if (moreInfoButton) {
      moreInfoButton.addEventListener('click', function () {
        ww_bzga_matomo_set_moreinfo();
      });
    }
  }

  const matomoElements = document.querySelectorAll('.ww_bzga_matomo');
  matomoElements.forEach(function (element) {
    element.style.display = 'block';

    const optoutYes = element.querySelector('.optout_yes');
    const optoutNo = element.querySelector('.optout_no');

    if (allow == 2) {
      if (optoutYes) optoutYes.style.display = 'block';
      if (optoutNo) optoutNo.style.display = 'none';
    } else {
      if (optoutNo) optoutNo.style.display = 'block';
      if (optoutYes) optoutYes.style.display = 'none';
    }

    const expire = element.dataset.expire;

    const setOptoutYes = element.querySelector('.set_optout_yes');
    const setOptoutNo = element.querySelector('.set_optout_no');

    if (setOptoutYes) {
      setOptoutYes.addEventListener('click', function () {
        ww_bzga_matomo_set_tracking(2, expire);
        location.reload();
      });
    }

    if (setOptoutNo) {
      setOptoutNo.addEventListener('click', function () {
        ww_bzga_matomo_set_tracking(1, expire);
        location.reload();
      });
    }
  });
}

function ww_bzga_matomo_set_tracking_code() {
  var configElement = document.querySelector('.ww_bzga_matomo_config');

  if (configElement) {
    // Get the value of the data-matomoSiteId attribute
    var matomoSiteId = configElement.getAttribute('data-matomoSiteId');
    var matomoDownloadClasses = configElement.getAttribute('data-matomoDownloadClasses');
    var matomoTrackPageView = configElement.getAttribute('data-matomoTrackPageView');
    var matomoLinkTracking = configElement.getAttribute('data-matomoLinkTracking');
    var matomoHeartBeatTimer = configElement.getAttribute('data-matomoHeartBeatTimer');

    if (matomoSiteId && matomoSiteId != 0) {
      window._paq = window._paq || [];
      window._paq.push(['setDocumentTitle', document.domain + '/' + document.title]);
      window._paq.push(['disableCookies']);
      window._paq.push(['setSiteId', matomoSiteId]);
      if (matomoDownloadClasses) {
        window._paq.push(['setDownloadClasses', matomoDownloadClasses]);
      }
      if (matomoTrackPageView) {
        window._paq.push(['trackPageView']);
      }
      if (matomoLinkTracking) {
        window._paq.push(['enableLinkTracking']);
      }
      if (matomoHeartBeatTimer) {
        window._paq.push(['enableHeartBeatTimer', matomoHeartBeatTimer]);
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  ww_bzga_matomo_init();
  setTimeout(function () {
    ww_bzga_matomo_set_tracking_code();
    activateCookiebanner();
  }, 250);
});
